export const newLineToSpace = (text: any) => {
  return text?.replace('\n', ' ')
}
